import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend) // Load translations from the backend
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .use(LanguageDetector) // Auto-detect user language
  .init({
    fallbackLng: 'en', // Default language if the detected one is not available
    debug: true, // Enable debugging to see logs in the console
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files on the server
    },
    ns: ['landingPage', 'navigation', 'aboutPage'], // Namespaces for different parts of the app
    defaultNS: 'navigation', // Default namespace for general translations
    detection: {
      // Optional settings for language detection
      order: ['querystring', 'cookie', 'localStorage', 'navigator'], // Customize order of detection
      caches: ['cookie', 'localStorage'], // Cache language in cookies/localStorage
    },
  });

export default i18n;
